<template>
  <section>
    <!--列表-->
    <el-table
      :data="records"
      v-loading="listLoading"
      class="custom-tbl"
      style="width: 100%"
    >
      <el-table-column type="index" min-width="10"></el-table-column>
      <el-table-column
        prop="integral"
        label="积分变化"
        min-width="20"
      >
      <template slot-scope="scope">{{scope.row.integral>=0 ? "+"+scope.row.integral: scope.row.integral}}</template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="描述"
        min-width="40"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="时间"
        min-width="30"
        sortable
      ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        hide-on-single-page
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
      >
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import { queryUserIntegralListPage } from "../../api/api";
import Toolbar from "../../components/Toolbar";

export default {
  props:{
    userId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      filter: {
        page: 1,
        pageSize: 10,
        key: "",
        data: {
          userId: 0
        }
      },
      listLoading: false,
      records: [],
      pageModel: {}
    };
  },
  methods: {
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    handleQuery() {
      this.listLoading = true;
      this.filter.data.userId = this.userId;
      queryUserIntegralListPage(this.filter).then((res) => {
        this.listLoading = false;
        if(res.data.isSuccess){
          this.records = res.data.response.data;
          this.pageModel = res.data.response;
        }
      });
    }
  },
  mounted() {
    this.handleQuery();
  },
  watch: {
    userId(newVal, oldVal){
      if(newVal!=oldVal){
        this.records=[];
        this.handleQuery();
      }
    }
  }
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
